export const PROJECT_STATUS_COLORS = {
  draft: '#90a4ae',
  presented: '#5c9fd4',
  approved: '#66bb6a',
  lost: '#ef5350',
  sold: '#ab47bc',
};
